import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportcab() {



    const cardData = {

keyword: "Mumbai Airport Cabs",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai Airport Cabs for domestic and international airport transfers, corporate travel, hotel pickups, local commuting, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, and doorstep pickup and drop across Mumbai and nearby regions, we ensure a smooth, comfortable, and hassle-free travel experience for every passenger.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most frequently traveled destinations from Mumbai Airport, known for its IT parks, educational institutions, corporate hubs, and cultural lifestyle, making it ideal for business and family travel."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a famous hill station on the Mumbai–Pune route known for lush green valleys, waterfalls, caves, and pleasant monsoon weather, making it a top weekend getaway destination."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a major religious and wine tourism destination known for Trimbakeshwar Jyotirlinga, vineyards, temples, and scenic landscapes, frequently visited from Mumbai Airport."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba and attracts millions of devotees throughout the year for spiritual visits."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a popular hill station known for strawberry farms, viewpoints, lakes, and cool weather, making it ideal for family vacations and honeymoon trips."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s top beach destination known for nightlife, beaches, water sports, and coastal beauty, making it a popular long-distance cab route from Mumbai Airport."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal getaway near Mumbai known for beaches, forts, and peaceful weekend trips, frequently chosen by travelers for short vacations."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for Mahalaxmi Temple, cultural heritage, spicy cuisine, and historical attractions, making it a popular pilgrimage and cultural destination."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a scenic Konkan destination known for Ganpatipule Temple, beaches, mango farms, and beautiful coastal road journeys."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a historic city famous for Ajanta and Ellora Caves, Bibi Ka Maqbara, and rich Mughal and Maratha heritage tourism."
    }
],



services: [
{
name: "Mumbai Airport Cabs",
description: "Mumbai Airport Cabs by 1Touch Cabs provides reliable, safe, and 24x7 airport transportation for arrivals and departures. We offer well-maintained vehicles including Sedan, Swift Dzire, Ertiga, Kia Carens, SUV, Innova, Innova Crysta, and Luxury Cars with professional chauffeurs, ensuring smooth pickup, drop, and intercity travel across Maharashtra and nearby states.",
},
{
name: "Mumbai Airport Car Rental",
description: "Mumbai Airport Car Rental service offers flexible transportation for airport transfers, local travel, business trips, and outstation journeys. With multiple vehicle options and professional drivers, we ensure comfortable and affordable travel solutions.",
},
{
name: "Airport Taxi Mumbai",
description: "Airport Taxi Mumbai service provides timely and dependable taxi rides to and from Mumbai Airport. We ensure clean AC vehicles, experienced drivers, and smooth travel to all major destinations.",
},
{
name: "Mumbai Airport Transfer",
description: "Mumbai Airport Transfer service offers seamless pickup and drop solutions between Mumbai Airport, hotels, homes, railway stations, and nearby cities with 24x7 availability and professional chauffeurs.",
},
{
name: "Mumbai Airport Taxi",
description: "Mumbai Airport Taxi service ensures safe, comfortable, and punctual transportation for all passengers with easy booking, verified drivers, and clean vehicles.",
},
{
name: "Mumbai Airport Taxi Booking",
description: "Mumbai Airport Taxi Booking allows quick online reservations with instant confirmation, transparent pricing, and multiple vehicle options for all travel needs.",
},
{
name: "Car Hire Mumbai Airport",
description: "Car Hire Mumbai Airport service provides flexible vehicle rental options for airport transfers, outstation travel, corporate trips, and family journeys with professional chauffeurs.",
},
{
name: "Airport Cabs Mumbai",
description: "Airport Cabs Mumbai service ensures reliable and affordable transportation for airport pickup and drop with 24x7 availability and comfortable vehicles.",
},
{
name: "Mumbai Airport to Outstation Cab",
description: "Mumbai Airport to Outstation Cab service provides long-distance travel to destinations like Pune, Goa, Nashik, Shirdi, Lonavala, Mahabaleshwar, and more with safe and comfortable rides.",
},
{
name: "Mumbai Airport Outstation Taxi",
description: "Mumbai Airport Outstation Taxi service offers intercity travel with experienced drivers, AC vehicles, and flexible one-way and round-trip options.",
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai Airport to Pune Cab service provides fast and comfortable highway travel with door-to-door pickup, ideal for business and family trips.",
},
{
name: "Mumbai Airport to Goa Cab",
description: "Mumbai Airport to Goa Cab service offers long-distance coastal travel with safe drivers, comfortable vehicles, and flexible travel packages.",
},
{
name: "Mumbai Airport to Lonavala Cab",
description: "Mumbai Airport to Lonavala Cab service provides quick hill station travel with scenic routes, perfect for weekend trips and short getaways.",
},
{
name: "Mumbai Airport to Nashik Cab",
description: "Mumbai Airport to Nashik Cab service ensures safe travel to the wine capital with reliable chauffeurs and comfortable AC vehicles.",
},
{
name: "Mumbai Airport to Mahabaleshwar Cab",
description: "Mumbai Airport to Mahabaleshwar Cab service offers scenic hill station travel with smooth driving and comfortable vehicles for families and tourists.",
},
{
name: "Mumbai Airport to Shirdi Cab",
description: "Mumbai Airport to Shirdi Cab service provides pilgrimage travel with professional drivers and safe highway journeys for devotees.",
},
{
name: "Mumbai Airport to Kolhapur Cab",
description: "Mumbai Airport to Kolhapur Cab service ensures long-distance travel with comfortable vehicles and experienced chauffeurs for family and business trips.",
},
{
name: "Mumbai Airport to Pune One Way Cab",
description: "Mumbai Airport to Pune One Way Cab service offers affordable single-trip travel without return charges, ideal for budget travelers.",
},
{
name: "Mumbai Airport to Navi Mumbai Taxi",
description: "Mumbai Airport to Navi Mumbai Taxi service provides quick and convenient airport transfers with doorstep pickup and drop facilities.",
},
{
name: "Mumbai Airport to Alibaug Taxi",
description: "Mumbai Airport to Alibaug Taxi service offers coastal travel with comfortable vehicles and safe driving for leisure trips and weekend getaways.",
},
{
name: "Mumbai Airport to Igatpuri Cab",
description: "Mumbai Airport to Igatpuri Cab service provides hill station travel with smooth routes and professional chauffeurs for a relaxing journey.",
},
{
name: "Mumbai Airport to Trimbakeshwar Taxi",
description: "Mumbai Airport to Trimbakeshwar Taxi service offers pilgrimage travel with safe and reliable vehicles for temple visits and spiritual tours.",
},
{
name: "Mumbai Airport to Ratnagiri Cab",
description: "Mumbai Airport to Ratnagiri Cab service provides scenic Konkan travel with comfortable vehicles and experienced drivers.",
},
{
name: "Mumbai Airport to Konkan Tour Taxi",
description: "Mumbai Airport to Konkan Tour Taxi service offers customized coastal tour packages with flexible itineraries and comfortable travel options.",
},
{
name: "Mumbai Airport Innova Cab",
description: "Mumbai Airport Innova Cab service provides spacious and comfortable travel ideal for families, groups, and long-distance journeys.",
},
{
name: "Mumbai Airport Innova Crysta Cab",
description: "Mumbai Airport Innova Crysta Cab service offers premium comfort, luxury interiors, and smooth rides for executive and family travel.",
},
{
name: "Mumbai Airport Ertiga Cab",
description: "Mumbai Airport Ertiga Cab service provides economical and comfortable travel for small families and group journeys.",
},
{
name: "Mumbai Airport Swift Dzire Cab",
description: "Mumbai Airport Swift Dzire Cab service offers budget-friendly and reliable travel for airport transfers and short trips.",
},
{
name: "Mumbai Airport Sedan Cab",
description: "Mumbai Airport Sedan Cab service ensures comfortable and affordable rides for solo travelers and business trips.",
},
{
name: "Mumbai Airport SUV Cab",
description: "Mumbai Airport SUV Cab service provides spacious and powerful vehicles for long-distance and group travel with extra comfort.",
},
{
name: "Mumbai Airport Kia Carens Cab",
description: "Mumbai Airport Kia Carens Cab service offers modern comfort, spacious seating, and smooth travel for families and groups.",
},
{
name: "Best Mumbai Airport Cabs",
description: "Best Mumbai Airport Cabs service by 1Touch Cabs ensures reliable, affordable, and 24x7 transportation with professional drivers and a wide range of vehicle options for all travel needs."
}
],

tableData: [
["Mumbai Airport Cabs","Mumbai Airport Car Rental"],
["Airport Taxi Mumbai","Mumbai Airport Transfer"],
["Mumbai Airport Taxi","Mumbai Airport Taxi Booking"],
["Car Hire Mumbai Airport","Airport Cabs Mumbai"],
["Mumbai Airport to Outstation Cab","Mumbai Airport Outstation Taxi"],
["Mumbai Airport to Pune Cab","Mumbai Airport to Goa Cab"],
["Mumbai Airport to Lonavala Cab","Mumbai Airport to Nashik Cab"],
["Mumbai Airport to Mahabaleshwar Cab","Mumbai Airport to Shirdi Cab"],
["Mumbai Airport to Kolhapur Cab","Mumbai Airport to Pune One Way Cab"],
["Mumbai Airport to Navi Mumbai Taxi","Mumbai Airport to Alibaug Taxi"],
["Mumbai Airport to Igatpuri Cab","Mumbai Airport to Trimbakeshwar Taxi"],
["Mumbai Airport to Ratnagiri Cab","Mumbai Airport to Konkan Tour Taxi"],
["Mumbai Airport Innova Cab","Mumbai Airport Innova Crysta Cab"],
["Mumbai Airport Ertiga Cab","Mumbai Airport Swift Dzire Cab"],
["Mumbai Airport Sedan Cab","Mumbai Airport SUV Cab"],
["Mumbai Airport Kia Carens Cab","Best Mumbai Airport Cabs"]
],





















whychoose: [
    {
        WhyChooseheading: "Trusted Mumbai Airport Cabs Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides reliable airport transportation services for domestic and international travelers, ensuring safe, comfortable, and punctual journeys across Mumbai and nearby destinations."
    },
    {
        WhyChooseheading: "24x7 Airport Pickup and Drop Facility",
        WhyChoosedescription: "Our airport cab services operate round the clock, making it easy for passengers to travel to and from Mumbai Airport at any time of the day or night."
    },
    {
        WhyChooseheading: "Domestic and International Airport Transfers",
        WhyChoosedescription: "We provide seamless transportation services for both domestic and international terminals, helping passengers enjoy hassle-free airport travel."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Airport to Local and Outstation Destinations",
        WhyChoosedescription: "Book direct airport transfers from Mumbai Airport to Navi Mumbai, Thane, Pune, Nashik, Lonavala, Shirdi, Mahabaleshwar, Goa, Surat, Ahmedabad, and many other destinations."
    },
    {
        WhyChooseheading: "Flight Tracking and Timely Pickup",
        WhyChoosedescription: "Our team monitors flight schedules to ensure timely pickups even if your flight is delayed, rescheduled, or arrives ahead of schedule."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, route expertise, punctual service, and a comfortable travel experience throughout your journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Corporate Travelers",
        WhyChoosedescription: "From solo travelers and families to business executives and corporate teams, we provide suitable airport transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What services are offered by Mumbai Airport Cabs?",
        answer: "We provide airport pickup and drop services, local taxi services, outstation cab bookings, corporate transportation, sightseeing tours, and customized travel solutions."
    },
    {
        question: "Can I pre-book a cab for Mumbai Airport?",
        answer: "Yes, customers can pre-book airport cabs in advance to ensure timely pickups and smooth transportation."
    },
    {
        question: "Which vehicles are available for airport transfers?",
        answer: "Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Do you provide airport pickup and drop services 24/7?",
        answer: "Yes, our airport cab services are available throughout the day and night according to customer travel schedules."
    },
    {
        question: "Can I book a cab from Mumbai Airport to Pune or Goa?",
        answer: "Yes, we provide direct airport transfers to Pune, Goa, Nashik, Shirdi, Mahabaleshwar, Lonavala, Surat, Ahmedabad, and many other destinations."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, tourists, wedding guests, and corporate teams."
    },
    {
        question: "Do drivers monitor flight arrival schedules?",
        answer: "Yes, flight timings are tracked to ensure timely pickups even if flights are delayed or rescheduled."
    },
    {
        question: "Can corporate companies use your airport cab services?",
        answer: "Yes, many organizations use our airport transportation services for executives, employees, business travelers, and client transfers."
    },
    {
        question: "Is advance booking recommended for airport transportation?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth airport travel arrangements."
    },
    {
        question: "How can I book Mumbai Airport Cabs?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vikram Shah",
        feedback:
            "Excellent airport transfer service with punctual pickup and a very professional driver. The vehicle was clean, comfortable, and ideal for our family travel.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anjali Patil",
        feedback:
            "Highly satisfied with the service quality. Smooth airport pickup, courteous chauffeur, and hassle-free transportation made the entire journey stress-free.",
        rating: 5
    }
];

















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport Cabs",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-airport-cabs.jpg",
  "description": "Book Mumbai Airport Cabs for reliable airport transfers, local rides, and outstation travel. Mumbai Airport Cabs offers professional chauffeurs, clean AC vehicles, 24x7 availability, and affordable taxi booking for Pune, Goa, and all major routes.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "15000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/"
  }
};



    return (
        <div>


<Helmet>
  <title>Mumbai Airport Cabs | Airport Taxi & Outstation Cab Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai Airport Cabs for airport transfers, local rides, and outstation taxi service. Safe, reliable, and affordable cab booking for Mumbai Airport."
  />

  <meta
    name="keywords"
    content="mumbai airport cabs, mumbai airport car rental, airport taxi mumbai, mumbai airport transfer, mumbai airport taxi, mumbai airport taxi booking, car hire mumbai airport, airport cabs mumbai, Mumbai Airport to Outstation Cab, Mumbai Airport Outstation Taxi, Mumbai Airport to Pune Cab, Mumbai Airport to Goa Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaiairportcab;